import z, { ZodType } from 'zod'

import { CenterLecComment } from '../../../../../../../lib/types/models/center-lec-comment/center-lec-comment'
import { CenterLecCommentInput } from '../../../../../../../lib/types/models/center-lec-comment/center-lec-input'
import { createStringSchema } from '../../../../../../../lib/utils/validations/string-validation'

export const mapCenterLecCommentToInput = (comment: CenterLecComment): CenterLecCommentInput => {
  return {
    comment: comment.comment,
    sharedToOl: comment.sharedToOl,
    updatedAt: comment.updatedAt
  }
}

export const centerLecCommentFormSchema: ZodType<Omit<CenterLecCommentInput, 'updatedAt'>> =
  z.object({
    comment: createStringSchema('Commentaire'),
    sharedToOl: z
      .boolean({ required_error: "Le commentaire doit être partagé à l'OL ou non" })
      .optional()
  })
